import { SelectOption } from '../../models';
import {
  CertificationEventCode,
  DutyEventCode,
  EngineEventCode,
  IntermediateEventCode,
  LogEventType,
  LoginEventCode,
  PersonalUseEventCode,
} from './log-event-type.enum';

export enum LogRecordStatus {
  Driving = 'driving',

  OffDuty = 'off-duty',
  PersonalConveyance = 'personal-conveyance',

  SleeperBerth = 'sleeper-berth',

  OnDuty = 'on-duty',
  YardMove = 'yard-move',

  IntermediateConventional = 'intermediate-conventional',
  IntermediateReduced = 'intermediate-reduced',

  Certification = 'certification',

  Login = 'login',
  Logout = 'logout',

  PowerOnConventional = 'power-on-conventional',
  PowerOnReduced = 'power-on-reduced',
  PowerOffConventional = 'power-off-conventional',
  PowerOffReduced = 'power-off-reduced',

  MalfunctionLogged = 'malfunction-logged',
  MalfunctionCleared = 'malfunction-cleared',
  DiagnosticLogged = 'diagnostic-logged',
  DiagnosticCleared = 'diagnostic-cleared',
}

export const LogRecordStatusOptions: SelectOption[] = [
  {
    label: 'Signature',
    value: LogRecordStatus.Certification,
    data: {
      eventType: LogEventType.Certification,
      eventCode: CertificationEventCode.Certification,
    },
  },
  {
    label: 'Intermediate',
    value: LogRecordStatus.IntermediateConventional,
    data: {
      eventType: LogEventType.Intermediate,
      eventCode: IntermediateEventCode.Conventioanl,
    },
  },
  {
    label: 'Power on',
    value: LogRecordStatus.PowerOnConventional,
    data: {
      eventType: LogEventType.Engine,
      eventCode: EngineEventCode.PowerOnConventional,
    },
  },
  {
    label: 'Power off',
    value: LogRecordStatus.PowerOffConventional,
    data: {
      eventType: LogEventType.Engine,
      eventCode: EngineEventCode.PowerOffConventional,
    },
  },
  {
    label: 'Log in',
    value: LogRecordStatus.Login,
    data: {
      eventType: LogEventType.Login,
      eventCode: LoginEventCode.Login,
    },
  },
  {
    label: 'Log out',
    value: LogRecordStatus.Logout,
    data: {
      eventType: LogEventType.Login,
      eventCode: LoginEventCode.Logout,
    },
  },
];

export const LogRecordDutyStatusOptions: SelectOption[] = [
  {
    value: LogRecordStatus.Driving,
    data: {
      eventType: LogEventType.Duty,
      eventCode: DutyEventCode.Driving,
    },
  },
  {
    value: LogRecordStatus.OnDuty,
    data: {
      eventType: LogEventType.Duty,
      eventCode: DutyEventCode.OnDuty,
    },
  },
  {
    value: LogRecordStatus.OffDuty,
    data: {
      eventType: LogEventType.Duty,
      eventCode: DutyEventCode.OffDuty,
    },
  },
  {
    value: LogRecordStatus.SleeperBerth,
    data: {
      eventType: LogEventType.Duty,
      eventCode: DutyEventCode.SleeperBerth,
    },
  },
  {
    value: LogRecordStatus.YardMove,
    data: {
      eventType: LogEventType.PersonalUse,
      eventCode: PersonalUseEventCode.YardMove,
    },
  },
  {
    value: LogRecordStatus.PersonalConveyance,
    data: {
      eventType: LogEventType.PersonalUse,
      eventCode: PersonalUseEventCode.PersonalConveyance,
    },
  },
];
